import styled from "styled-components";
import Triangle from "../assets/icons/triangle.png";
import { useEffect, useState } from "react";

const TitleSection = styled.section`
  background-image: url(${(props) => props.$backgroundImage});
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  width: 100%;
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const TitleSectionInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgb(0, 0, 0, 0.1);
  color: #fff;
  width: 100%;
  height: 100%;
  gap: 24px;
  padding-top: 20px;
`;

const TitleH2 = styled.h2`
  font-size: 52px;
  font-weight: 800;
  animation: fadeInDown 1.5s forwards;
  transition-delay: 0.4s;
`;

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  animation: fadeInDown 1.5s forwards;
  transition-delay: 0.4s;
  font-size: 14px;
`;

const HomeIconImg = styled.img`
  cursor: pointer;
  width: 22px;
`;

// Start of Selection
const ArrowIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 22px;
  img {
    width: 10px;
  }
`;

const SubMenuBarContainer = styled.div`
  background-color: var(--primary-c);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubMenuBarInner = styled.ul`
display: flex;
align-items: center;
justify-content: center;
max-width: 1120px;
width: 100%;
height: 54px;
font-size: 16px;
font-weight: 700;
box-sizing: border-box;
padding: 0 20px;
`

const SubMenuBarItem = styled.li`
  box-sizing: content-box;
  width: ${({ $menuListWidth }) => `${$menuListWidth}%`};
  height: 100%;
  color: #fff;
`;

const SubMenuBarItemSpan = styled.span`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;

  &.active {
    color: #186FB2;
    background-color: #fff;
    margin-top: -8px;
    height: 64px;
    border-radius: 10px 10px 0 0;
  }
`;

export default function SubVisual({ title, activeMenu, backgroundImage, menuList, setActiveMenu }) {
  const [menuListWidth, setMenuListWidth] = useState(0);

  useEffect(() => {
    const calcMenuListWidth = 100 / menuList.length;
    setMenuListWidth(Math.min(calcMenuListWidth, 50));
  }, [menuList]);


  const handleMenuClick = (menu) => {
    if (!setActiveMenu) return;
    setActiveMenu(menu);
  }

  return (
    <>
      <TitleSection $backgroundImage={backgroundImage}>
        <TitleSectionInner>
          <TitleH2>{title}</TitleH2>
          <Breadcrumb >
            {/* <HomeIconImg
            src={HomeIcon}
            alt="홈 아이콘"
            onClick={() => navigate("/")}
          /> */}
            <p>홈</p>
            <ArrowIconWrapper>
              <img src={Triangle} alt="화살표 아이콘" />
            </ArrowIconWrapper>
            <p>{title}</p>
            <ArrowIconWrapper>
              <img src={Triangle} alt="화살표 아이콘" />
            </ArrowIconWrapper>
            <p>{activeMenu}</p>
          </Breadcrumb>
        </TitleSectionInner>
      </TitleSection>
      <SubMenuBarContainer>
        <SubMenuBarInner>
          {menuList.map((menu, index) => (
            <SubMenuBarItem key={index} $menuListWidth={menuListWidth}>
              <SubMenuBarItemSpan className={activeMenu === menu ? "active" : ""} onClick={() => handleMenuClick(menu)}>{menu}</SubMenuBarItemSpan>
            </SubMenuBarItem>
          ))}
        </SubMenuBarInner>
      </SubMenuBarContainer>
    </>
  )
}

